import { PendingChangesActionType } from 'constants/pendingChanges';
import { COLOR_PALETTE } from 'constants/ui';

import { paperStyles } from './PendingChangesDrawer.styles';

export const ALL_SECTIONS_KEY = 'all';

export const ALL_SECTIONS_LABEL = 'All Changes';

export const PENDING_CHANGES_SUBTAB = 'pending-changes';

export const PendingChangesDrawerActionLabel = {
  SAVE: 'Save Changes',
  CANCEL: 'Cancel Changes',
};

export const SECTION_PREFIX = 'section:';

export const SUBGROUP_PREFIX = 'subgroup:';

export const ChangeKindFilter = {
  DIRECT: 'direct',
  RECALCULATED: 'recalculated',
};

export const PULSE_HIGHLIGHT_DURATION_MS = 2000;

export const POLL_INTERVAL_MS = 100;

export const POLL_MAX_ATTEMPTS = 30;

export const paperProps = {
  sx: paperStyles,
};

export const slideProps = {
  timeout: { enter: 300, exit: 300 },
  appear: true,
};

export const ChangeTypeBadgeConfig = {
  [PendingChangesActionType.ADDED]: {
    label: 'Added',
    color: COLOR_PALETTE.GREEN[8],
    backgroundColor: COLOR_PALETTE.GREEN[1],
  },
  [PendingChangesActionType.MODIFIED]: {
    label: 'Modified',
    color: COLOR_PALETTE.ORANGE[8],
    backgroundColor: COLOR_PALETTE.ORANGE[1],
  },
  [PendingChangesActionType.DELETED]: {
    label: 'Deleted',
    color: COLOR_PALETTE.RED[8],
    backgroundColor: COLOR_PALETTE.RED[1],
  },
};

export const AFFECTED_BADGE_CONFIG = {
  label: 'Affected',
  color: COLOR_PALETTE.GRAY[8],
  backgroundColor: COLOR_PALETTE.GRAY[2],
};
